var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M31.6667 18.3333C31.6667 10.9695 25.6972 5 18.3333 5C10.9695 5 5 10.9695 5 18.3333C5 25.6972 10.9695 31.6667 18.3333 31.6667C25.6972 31.6667 31.6667 25.6972 31.6667 18.3333Z",
    fill: "#7C7F7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.333 28.333L34.9997 34.9997",
    stroke: "#7C7F7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 18.3333C31.6667 10.9695 25.6972 5 18.3333 5C10.9695 5 5 10.9695 5 18.3333C5 25.6972 10.9695 31.6667 18.3333 31.6667C25.6972 31.6667 31.6667 25.6972 31.6667 18.3333Z",
    stroke: "#7C7F7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 13.333L18.333 18.333M18.333 18.333L23.333 23.333M18.333 18.333L23.333 13.333M18.333 18.333L13.333 23.333",
    stroke: "#7C7F7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchEmpty);
export default __webpack_public_path__ + "static/media/search-empty.4cb8a749382f5930437ab4cb00db5767.svg";
export { ForwardRef as ReactComponent };